import aws_exports from "./aws-exports";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

import { Amplify } from "aws-amplify";
import amplifyconfig from "./amplifyconfiguration.json";

import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';

addIcons(allIcons);
amplifyconfig["aws_user_pools_id"] = environment.aws_user_pools_id;
amplifyconfig["aws_user_pools_web_client_id"] =
  environment.aws_user_pools_web_client_id;
amplifyconfig["oauth"]["domain"] = environment.oauth_domain;
amplifyconfig["oauth"]["scope"] = [
  "email",
  "profile",
  "openid",
  "aws.cognito.signin.user.admin",
];
amplifyconfig["oauth"]["redirectSignIn"] = environment.oauth_redirectSignIn;
amplifyconfig["oauth"]["redirectSignOut"] = environment.oauth_redirectSignOut;
amplifyconfig["oauth"]["responseType"] = "code";
amplifyconfig["aws_cognito_signup_attributes"] = ["EMAIL"];
amplifyconfig["aws_cognito_verification_mechanisms"] = ["EMAIL"];
amplifyconfig["identityPoolId"] = environment.identityPoolId;

Amplify.configure(amplifyconfig);

/*if (environment.production) {
  enableProdMode();
}*/

bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
